import { gql } from '@apollo/client';

export const GET_COMPLIANCE_QUERY = gql`
  query ComplianceMessagingProvider($propertyId: String!, $applicationId: String!) {
    property(id: $propertyId) {
      id
      application(id: $applicationId) {
        id
        complianceList {
          id
          body
          hasBeenAccepted
        }
      }
    }
  }
`;

export const GET_ICRAA_PAGE_CONFIG_QUERY = gql`
  query IcraaPageConfigProvider($propertyId: String!, $applicationId: String!) {
    property(id: $propertyId) {
      id
      application(id: $applicationId) {
        id
        icraaPageConfig {
          complianceType
          header
          body {
            type
            textList
            text
            richText {
              text
              unorderedList {
                text
              }
              bold
              anchor {
                text
                href
              }
            }
            form {
              id
              options {
                type
                id
                label
              }
            }
          }
          callToActionLabel
          finePrint
          appliesTo
          requiredForms
          hasBeenAcceptedFor
        }
      }
    }
  }
`;

// isIcraaApplicable will be sent as a string of either "True" or "False" and be parsed as a boolean by RMA
export const ACCEPT_ICRAA_MUTATION = gql`
  mutation AcceptIcraa(
    $zuidIrene: String!
    $zuids: [String]!
    $listingAlias: String!
    $complianceType: String!
    $applicationId: String!
    $isIcraaApplicable: String
  ) {
    acceptIcraa(
      zuidIrene: $zuidIrene
      zuids: $zuids
      listingAlias: $listingAlias
      complianceType: $complianceType
      applicationId: $applicationId
      isIcraaApplicable: $isIcraaApplicable
    ) {
      success
      complianceType
    }
  }
`;
